import { InputLabel, ListItem, Slider } from "@mui/material";
import { useState } from "react";
import { AutocompleteInput, ReferenceInput } from "../../components";
import { useWebsite } from "../../hooks";
import { MenuGroup } from "../../layout/menu-group";
import type { Filter } from "../../models";

export function SpecGroup({
    group,
    spec,
    categoryId,
    setValue
}: {
    group: string;
    spec: Filter[];
    categoryId: number;
    setValue: (name: string, value: string) => void;
}): JSX.Element {
    const [open, setOpen] = useState(true);
    const { accountId } = useWebsite();
    return (
        <MenuGroup open={open} onClick={() => setOpen(!open)} name={group.toString()} key={group}>
            {spec
                .filter(f => f.categoryId == categoryId)
                .map(f => {
                    const min = Number.parseFloat(f.min);
                    const max = Number.parseFloat(f.max);
                    const unit = f.unit ? f.unit.slice(2) : f.unit;
                    return (
                        <ListItem key={f.id!} sx={f.unit ? { paddingLeft: 2, paddingRight: 2, display: "block" } : {}}>
                            {f.unit ? <>
                            <InputLabel>{f.name}</InputLabel>
                                <Slider
                                    min={min}
                                    max={max}
                                    marks={[
                                        { value: min, label: `${f.min}` },
                                        { value: max, label: `${f.max}` },
                                    ]}
                                    step={(max - min) / 20}
                                    defaultValue={[min, max] as [number, number]}
                                    onChangeCommitted={(_, val: any) => {
                                        if (val[0] !== min || val[1] !== max) {
                                            setValue("tag", toTag(f.specificationId, (val as number[]).map(x => `${x}${unit}`)));
                                        } else {
                                            setValue("tag", "");
                                        }
                                    }}
                                />
                            </> : (
                                <ReferenceInput source="tag" reference="tag" filter={{ accountId, categoryId, specificationId: f.specificationId }}>
                                    <AutocompleteInput
                                        source="name"
                                        optionText="value"
                                        optionValue="value"
                                        onChange={val => setValue("tag", toTag(f.specificationId, [(val as string)].map(x => `${x}`)))}
                                />
                                </ReferenceInput>  
                            )}
                        </ListItem>
                    );
                })}
        </MenuGroup>
    );
}

const toTag = (filterId: number, values: string[]) => `${filterId}-${values.join("-")}`;